import { Button, message, Modal, Space, Table, Tag, Tooltip } from 'antd'
import './secondHandTable.css'
import { Navigate, useNavigate } from 'react-router-dom'
import { forwardRef } from 'react'
import { useState } from 'react'
import { useImperativeHandle } from 'react'
import {
  changeMarketItem,
  deleteMarketItem,
  deleteShare,
  getCategories,
} from '../../../../api/api'
import moment from 'moment/moment'
import { isVisible } from '@testing-library/user-event/dist/utils'
import SecondHandPriority from '../secondHandPriority/secondHandPriority'

const SecondHandTable = forwardRef((props, ref) => {
  const [data, setData] = useState([])
  const { setFresh } = props

  const handleHide = (record) => {
    const params = {
      id: record.id,
      is_on_sale: record.is_on_sale ? 0 : 1,
    }
    changeMarketItem(params)
      .then((res) => {
        console.log(res)
        message.success('修改展示状态成功')
        setFresh((pre) => !pre)
      })
      .catch((err) => {
        console.log(err)
        message.err('修改展示状态失败')
      })
  }
  const columns = [
    {
      title: '内容编号',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },
    {
      title: '内容标题',
      dataIndex: 'title',
      key: 'title',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
      render: (title) => (
        <Tooltip placement="topLeft" title={title}>
          {title}
        </Tooltip>
      ),
    },
    {
      title: '分类',
      key: 'category',
      dataIndex: 'category',
      width: 80,

      ellipsis: {
        showTitle: false,
      },
      render: (category_name) => (
        <Tooltip placement="topLeft" title={category_name}>
          {category_name}
        </Tooltip>
      ),
    },
    {
      title: '价格（£）',
      key: 'price',
      width: 150,
      dataIndex: 'price',
    },
    {
      title: '上架状态',
      key: 'is_on_sale',
      dataIndex: 'is_on_sale',
      width: 100,
      render: (is_visible) => {
        return <>{is_visible ? '已上架' : '已下架'}</>
      },
    },
    {
      title: '优先级',
      key: 'priority',
      width: 80,
      dataIndex: 'priority',
    },
    {
      title: '发布时间',
      key: 'createdAt',
      width: 200,
      dataIndex: 'createdAt',
      ellipsis: {
        showTitle: false,
      },
      render: (created_at) => (
        <Tooltip placement="topLeft" title={created_at}>
          {created_at}
        </Tooltip>
      ),
    },
    {
      title: '最后修改时间',
      key: 'updatedAt',
      width: 200,
      dataIndex: 'updatedAt',
      ellipsis: {
        showTitle: false,
      },
      render: (updated_at) => (
        <Tooltip placement="topLeft" title={updated_at}>
          {updated_at}
        </Tooltip>
      ),
    },

    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: 240,
      render: (_, record) => (
        <Space size="middle">
          <a onClick={() => jumpToEditor(record)}>编辑</a>
          <a onClick={() => deleteSecondHand(record.id)}>删除</a>
          <SecondHandPriority
            id={record.id}
            value={record.priority}
            setIsFresh={setFresh}
            name="is_prioritized"
          />
          <a onClick={() => handleHide(record)}>
            {record.is_on_sale ? '下架' : '上架'}
          </a>
        </Space>
      ),
    },
  ]
  const switchIs = (num) => {
    switch (num) {
      case 0:
        return '否'
        break
      case 1:
        return '是'
        break
      default:
        break
    }
  }

  const switchIsOnSale = (num) => {
    switch (num) {
      case 0:
        return '已结束'
        break
      case 1:
        return '售卖中'
        break
      default:
        break
    }
  }
  const findName = (list, target) => {
    for (let subList of list) {
      if (subList.ID === target) {
        return subList.Name
      }
      if (subList.SubCategories) {
        let res = findName(subList.SubCategories, target)
        if (res) return res
      }
    }
  }

  const changeData = async (data) => {
    const list = await getCategories({
      params: { type: 1 },
    })

    data.map((info, index) => {
      info.key = index
      info.isVisible = switchIs(info.is_visible)
      info.createdAt = moment(info.created_at).format('YYYY-MM-DD HH:mm:ss')
      info.updatedAt = moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss')

      //初始化cascader
      const name = findName(list.data.data.Categories, info.category_id)
      info.category_name = name
      // console.log('casacder name',name);
      return info
    })
    setData(data)
  }

  useImperativeHandle(ref, () => ({
    changeData,
  }))

  let navigate = useNavigate()
  const jumpToEditor = (info) => {
    //将本列的详细数据传递给编辑页面
    navigate('/newSecondHand', { state: { state: 'edit', info: info } })
  }
  //删除数据的回调
  const deleteSecondHand = (id) => {
    Modal.confirm({
      title: '请确认',
      //  icon: <ExclamationCircleOutlined />,
      content: '您确定要删除此内容吗？删除后不可恢复。',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        deleteMarketItem(id)
          .then((res) => {
            const newData = data.filter((item) => item.id !== id)
            setData(newData)
            message.success('删除内容成功！')
          })
          .catch((err) => console.log(err))
      },
    })
  }

  return (
    <div className="secondHandTable" style={{ marginBottom: '20px' }}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        scroll={{
          x: 1400,
          y: 400,
        }}
      />
    </div>
  )
})

export default SecondHandTable
